import {
  FileFilled,
  HomeFilled,
  WalletFilled,
  CreditCardOutlined,
} from '@ant-design/icons'
import { Avatar, Col, Menu, Row } from 'antd'
import { push } from 'connected-react-router'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import { matchPath, useLocation } from 'react-router'
import styled from 'styled-components'
import { AnimatedMenu, Header, TranslatedMessage } from '@library/react-toolkit'
import { useIsSmartHubAdmin } from '../../queries'

const Nav = styled(Menu)`
  display: flex;
  height: ${props => props.theme.headerHeight}px;
  background: ${props => props.theme.colors.primary};
  border: 0;
  & > li.ant-menu-item.ant-menu-item-selected,
  & > li.ant-menu-item.ant-menu-item-active,
  & > li.ant-menu-submenu.ant-menu-item-selected,
  & > li.ant-menu-submenu.ant-menu-submenu-selected,
  & > li.ant-menu-submenu.ant-menu-submenu-active {
    background: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primary};
  }
  & > li.ant-menu-item,
  & > li.ant-menu-submenu {
    vertical-align: top;
    top: 0px;
    margin: 0 !important;
    height: ${props => props.theme.headerHeight}px;
    line-height: ${props => props.theme.headerHeight}px;
    font-size: 18px;
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    & > .anticon {
      font-size: 18px;
    }
  }
  & > li.ant-menu-item {
    padding: 0 20px !important;
  }
  & > li.ant-menu-submenu > div {
    padding: 0 20px !important;
  }
`
type menuKey = { key: string }

const NavMenu = () => {
  const dispatch = useDispatch()

  const [isHoveringInvoices, setIsHoveringInvoices] = React.useState(false)

  const location = useLocation()
  const page = matchPath(location.pathname, '/bills')
    ? 'bills'
    : matchPath(location.pathname, '/wallet')
    ? 'wallet'
    : matchPath(location.pathname, { path: '/', exact: true })
    ? 'home'
    : 'other'

  const billsPage = matchPath(location.pathname, {
    path: '/bills',
    exact: true,
  })
    ? 'bills'
    : matchPath(location.pathname, 'bills/taxes')
    ? 'taxes'
    : matchPath(location.pathname, '/bills/discounts')
    ? 'discounts'
    : matchPath(location.pathname, '/bills/items')
    ? 'items'
    : matchPath(location.pathname, '/bills/payers')
    ? 'payers'
    : 'other'

  const billsOnSelect = ({ key }: menuKey) => {
    switch (key) {
      case 'bills':
        dispatch(push('/bills'))
        break
      case 'payers':
        dispatch(push('/bills/payers'))
        break
      case 'items':
        dispatch(push('/bills/items'))
        break
      case 'discounts':
        dispatch(push('/bills/discounts'))
        break
      case 'taxes':
        dispatch(push('/bills/taxes'))
        break
      default:
        break
    }
  }

  const isSmartHubAdmin = useIsSmartHubAdmin()

  return (
    <>
      <Header
        filterWorkspaces={() => true}
        extraModules={
          isSmartHubAdmin ? (
            <Menu.Item
              key="bills-admin-app"
              onClick={() => {
                window.location.href = '/bills-admin-app'
              }}
            >
              <Row style={{ width: '200px' }} align="middle">
                <Col flex={2}>
                  <Avatar icon={<CreditCardOutlined />} />
                </Col>
                <Col>
                  <a href="/bills-admin-app" />
                  <TranslatedMessage id="BILLS_ADMIN" />
                </Col>
              </Row>
            </Menu.Item>
          ) : null
        }
      >
        <Nav
          mode="horizontal"
          disabledOverflow={true}
          defaultSelectedKeys={[page]}
          selectedKeys={[page]}
          onSelect={({ key }) => {
            switch (key) {
              case 'home':
                dispatch(push('/'))
                break
              case 'bills':
                dispatch(push('/bills'))
                break
              case 'wallet':
                dispatch(push('/wallet'))
                break
              default:
                break
            }
          }}
        >
          <Menu.Item
            key="home"
            icon={<HomeFilled />}
            onMouseOver={() => {
              setIsHoveringInvoices(false)
            }}
          >
            <FormattedMessage id="home" />
          </Menu.Item>
          <Menu.Item
            key="bills"
            icon={<FileFilled />}
            onMouseOver={() => {
              setIsHoveringInvoices(true)
            }}
          >
            <FormattedMessage id="invoices" />
          </Menu.Item>
          <Menu.Item
            key="wallet"
            icon={<WalletFilled />}
            onMouseOver={() => {
              setIsHoveringInvoices(false)
            }}
          >
            <FormattedMessage id="wallet" />
          </Menu.Item>
        </Nav>
      </Header>
      <AnimatedMenu
        visible={isHoveringInvoices}
        duration={100}
        selectedKeys={[billsPage]}
        onSelect={billsOnSelect}
      >
        <Menu.Item key="bills">
          <FormattedMessage id="invoices" />
        </Menu.Item>
        <Menu.Item key="payers">
          <FormattedMessage id="customers" />
        </Menu.Item>
        <Menu.Item key="items">
          <FormattedMessage id="items" />
        </Menu.Item>
        <Menu.Item key="discounts">
          <FormattedMessage id="Discount_Header" />
        </Menu.Item>
        <Menu.Item key="taxes">
          <FormattedMessage id="Tax_Header" />
        </Menu.Item>
      </AnimatedMenu>
    </>
  )
}

export default NavMenu
